import React, { useState } from 'react';

const PassphraseUnlock = ({ onSuccess, onError }) => {
  const [passphrase, setPassphrase] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [showPassphrase, setShowPassphrase] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passphrase.trim()) {
      setMessage({ type: 'error', text: 'Please enter your passphrase' });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      if (onSuccess) {
        const result = await onSuccess(passphrase);
        if (result?.success) {
          setMessage({ type: 'success', text: 'Wallet unlocked!' });
          // Parent will handle next steps
        } else {
          const errorMsg = result?.error || 'Incorrect passphrase';
          setMessage({ type: 'error', text: errorMsg });
          
          // If vault needs initialization, show helpful message
          if (errorMsg.includes('re-initialization') || errorMsg.includes('Vault salt not found')) {
            setMessage({ 
              type: 'error', 
              text: 'Vault not initialized. Please set up your passphrase first.' 
            });
          }
        }
      }
    } catch (err) {
      console.error('Error unlocking:', err);
      setMessage({ type: 'error', text: err.message || 'Failed to unlock wallet' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="passphrase-unlock-container" style={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '20px', color: '#fff' }}>Unlock Your Wallet</h2>
      
      <p style={{ color: '#999', fontSize: '14px', marginBottom: '20px' }}>
        Enter your passphrase to unlock your encrypted wallet keys.
      </p>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', color: '#fff', marginBottom: '8px', fontSize: '14px' }}>
            Passphrase
          </label>
          <div style={{ position: 'relative' }}>
            <input
              type={showPassphrase ? 'text' : 'password'}
              placeholder="Enter your passphrase"
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              disabled={loading}
              autoFocus
              style={{
                width: '100%',
                padding: '12px 40px 12px 12px',
                borderRadius: '8px',
                border: '1px solid #333',
                backgroundColor: '#1a1a1a',
                color: '#fff',
                fontSize: '14px',
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassphrase(!showPassphrase)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                color: '#999',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              {showPassphrase ? 'Hide' : 'Show'}
            </button>
          </div>
        </div>

        {message ? (
          <div
            style={{
              padding: '10px',
              borderRadius: '6px',
              marginBottom: '15px',
              backgroundColor: message.type === 'error' ? 'rgba(255, 0, 0, 0.1)' : 'rgba(0, 255, 0, 0.1)',
              color: message.type === 'error' ? '#ff4444' : '#44ff44',
              fontSize: '14px',
            }}
          >
            {message.text}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={loading || !passphrase}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: '#6366f1',
            color: '#fff',
            fontSize: '16px',
            fontWeight: '600',
            cursor: loading || !passphrase ? 'not-allowed' : 'pointer',
            opacity: loading || !passphrase ? 0.6 : 1,
          }}
        >
          {loading ? 'Unlocking...' : 'Unlock Wallet'}
        </button>
      </form>
    </div>
  );
};

export default PassphraseUnlock;
